<nav #navElement [class]="'barra-navegacion ' + navbarClass()">
  <div class="barra-navegacion-container">
    <!-- LOGO: Convertido a button -->
    <button
      class="logo"
      (click)="onLogoClick($event)"
      type="button"
      aria-label="Ir a la página de inicio">
      <span [innerHTML]="logoSvg()"></span>
    </button>

    <!-- ENLACES DESKTOP (ocultos en móvil) -->
    <ul class="links-container">
      @for (item of items; track item.id) {
        <li class="link">
          <a
            [href]="'#' + item.redireccion"
            (click)="onNavItemClick(item, $event)">
            {{ item.titulo }}
          </a>
        </li>
      }
    </ul>

    <!-- BOTONES DESKTOP (ocultos en móvil) -->
    <div class="buttons-container">
      @if (!isLoggedIn()) {
        <button class="btn btn-login" (click)="goToLogin()" type="button">
          Ingresa a tu cuenta
        </button>
        <button class="btn btn-register" (click)="goToRegister()" type="button">
          Crear cuenta
        </button>
      }

      @if (isLoggedIn()) {
        <button class="btn btn-my-zone" (click)="goToMyZone()" type="button">
         Mi espacio
        </button>

        <!-- AVATAR: Convertido a button -->
        <button
          class="user-avatar"
          type="button"
          [style.background-color]="avatarColor()"
          (click)="goToMyProfile()"
          [attr.aria-label]="'Ir al perfil de ' + (username() || 'Usuario')"
          [title]="username() || 'Usuario'">
          <span class="user-initials" [style.color]="avatarTextColor()" aria-hidden="true">
            {{ userInitials() }}
          </span>
        </button>
      }
    </div>

    <!-- SECCIÓN DERECHA MÓVIL (Avatar + Menú) -->
    <div class="mobile-right-section">
      <!-- Avatar móvil: Convertido a button -->
      @if (isLoggedIn()) {
        <button
          class="mobile-user-avatar"
          type="button"
          [style.background-color]="avatarColor()"
          (click)="goToMyProfile()"
          [attr.aria-label]="'Ir al perfil de ' + (username() || 'Usuario')"
          [title]="username() || 'Usuario'">
          <span class="mobile-user-initials" [style.color]="avatarTextColor()" aria-hidden="true">
            {{ userInitials() }}
          </span>
        </button>
      }

      <!-- Botón hamburguesa con icono que cambia -->
      <button
        class="mobile-menu-toggle"
        type="button"
        (click)="toggleMobileMenu()"
        [attr.aria-label]="isMobileMenuOpen() ? 'Cerrar menú' : 'Abrir menú'"
        [attr.aria-expanded]="isMobileMenuOpen()">
        <lucide-icon
          [img]="isMobileMenuOpen() ? CloseIcon : MenuIcon"
          class="mobile-menu-icon"
          [size]="28"
          aria-hidden="true">
        </lucide-icon>
        <span class="mobile-menu-label" aria-hidden="true">
          {{ isMobileMenuOpen() ? 'Cerrar' : 'Menú' }}
        </span>
      </button>
    </div>
  </div>

  <!-- PANEL MENÚ MÓVIL DESLIZANTE -->
  <div
    [class]="'mobile-menu-panel ' + (isMobileMenuOpen() ? 'open' : '')"
    [attr.aria-hidden]="!isMobileMenuOpen()"
    role="navigation"
    [attr.aria-label]="'Menú de navegación móvil'">
    <!-- Enlaces de navegación -->
    <ul class="mobile-links-container">
      @for (item of items; track item.id) {
        <li class="mobile-link">
          <a
            [href]="'#' + item.redireccion"
            (click)="onNavItemClick(item, $event)">
            {{ item.titulo }}
          </a>
        </li>
      }
    </ul>

    <!-- Botones de acción al final -->
    <div class="mobile-buttons-container">
      @if (isLoggedIn()) {
        <button class="btn mobile-btn-my-zone" (click)="goToMyZone()" type="button">
          Mi espacio
        </button>

        <button class="btn mobile-btn-logout" (click)="onLogout()" type="button">
          <lucide-icon [img]="LogOutIcon" [size]="18" aria-hidden="true"></lucide-icon>
          <span>Cerrar sesión</span>
        </button>
      }

      @if (!isLoggedIn()) {
        <button class="btn mobile-btn-login" (click)="goToLogin()" type="button">
          Ingresa a tu cuenta
        </button>
        <button class="btn mobile-btn-register" (click)="goToRegister()" type="button">
          Crear cuenta
        </button>
      }
    </div>
  </div>

  <div [class]="'navbar-line ' + lineClass()"></div>
</nav>






